var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevArLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "7083.000000pt",
    height: "7083.000000pt",
    viewBox: "0 0 7083.000000 7083.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,7083.000000) scale(0.100000,-0.100000)",
    fill: "#00000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55438 58916 c-8460 -6553 -24394 -18893 -35408 -27423 l-20025 -15508 -3 -7994 c-2 -6535 0 -7992 11 -7988 7 3 9242 7152 20522 15889 11281 8736 27212 21073 35403 27417 l14892 11533 0 7994 c0 4397 -2 7994 -4 7994 -2 0 -6927 -5361 -15388 -11914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29539 11648 c-3232 -2521 -7912 -6171 -10401 -8113 l-4525 -3530 10405 -3 c5722 -1 15083 -1 20803 0 l10399 3 -3583 2795 c-10295 8031 -17217 13430 -17220 13430 -2 0 -2647 -2062 -5878 -4582z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevArLogoBlack);
export default __webpack_public_path__ + "static/media/levAR_logo_black.72e237f42164303448b491be02f8e17a.svg";
export { ForwardRef as ReactComponent };